import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, iminFAQ, iminOtherHadwares, iminPOSFeatures, testimonialData, tvsOtherHardware, tvsPOSFeatures, videoTestimonial , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import { hardwareFaq } from '@/constants/industry';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const IMINPOS = () => {

  const [demoModal, setDemoModal] = useState(false);
  const [formHeading, setHeading] = useState("Book your free demo now!");
  const router = useRouter();

  const { commonMarqueTitle } = getTitleContent();

  return (
    <>
      <div className={styles.verificationPopupOverride}>
        <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
      </div>
      <div className={styles.hero_section}>
        <div className={styles.text_container}>
          <div className={styles.hardware_logo}><Image src="/assets/Integration/Hardwares/imini.webp" alt="TVSE" fill /></div>
          <h1 className={styles.page_heading}>
            <span className={styles.small_black_text}>Top of The Line Business Operations</span><br />
            <span className={styles.black_text}>With</span><span className={styles.blue_text}> iMin POS Machine</span>
          </h1>
          <p className={styles.page_desc}>Witness a new era of smart Android POS devices with imin, enriched by QueueBuster's seamless integration for swift transactions and personalized service, fostering customer satisfaction and loyalty.</p>

          <div className={styles.btn_container}>
            <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
            <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
          </div>
        </div>
        <div className={styles.hero_img} style={{ height: "48rem", width: "48rem" }}><Image src="/assets/hardware-partners/imin/hero-img.webp" alt="imin" fill /></div>
      </div>

      <div className={styles.marquee_section}>
        <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
        <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
      </div>

      <div className={styles.portable_devices}>
        <h2>Maximize Your Business Efficiency With iMin POS Devices</h2>
        <HardwareFeatures features={iminPOSFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
      </div>

      <AdvanceAnalyticsBanner heading={'Transform Your iMin Hardware Into a Complete POS Solution'} desc={"All your iMin device needs is a makeover of a dynamic and flexibly integrated POS software built to last with rapid billing, easy inventory management and extensive real-time reporting."} setDemoModal={setDemoModal} setHeading={setHeading} />
      <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

      <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
      <TrustFactor />

      <FrequentQuestions FaqTableData={iminFAQ} heading={"FAQs for Imin's Versatile POS Hardware"} />
      <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
    </>
  )
}

export default IMINPOS